import { call, put, select } from 'redux-saga/effects';
import { normalize } from 'normalizr';

import { FETCH_CURRENT_USER, FETCH_CURRENT_MASTER, DISPATCH_HACK } from '@lib/actions/actionTypes';
import { usersResource } from '@lib/resources';
import { selectAuthUser, selectAuthMaster, selectCurrentUser, selectCurrentMaster } from '@lib/selectors';
import storage from '@lib/services/storageService';

import sagaFetch from './sagaFetch';

// bind resource generator
const fetchUser = sagaFetch.bind(null, FETCH_CURRENT_USER, usersResource.fetchUser);
const fetchMaster = sagaFetch.bind(null, FETCH_CURRENT_MASTER, usersResource.fetchUser);

export default function* sagaFetchCurrentUser() {
  // fetch current user
  const id = yield select(selectAuthUser);

  const request = yield call(fetchUser, { id });

  // skip here in case of error to retrieve the user
  if (!request || !request.data) {
    throw new Error(`Failed to fetch user with id: ${id}`);
  }

  // TODO: remove workaround for user token once containers use `storage.getToken` instead of `user.token`
  yield put({
    type: DISPATCH_HACK,
    normalized: normalize({ _id: id, token: storage.getToken() }, usersResource.schema),
  });

  // fetch current and master users
  const masterUserId = yield select(selectAuthMaster);
  const currentUser = yield select(selectCurrentUser);

  if (masterUserId && masterUserId !== id) {
    yield call(fetchMaster, { id: masterUserId });

    // TODO: remove workaround for user/master settings once containers use `selectCurrentMaster`
    if (!currentUser.userSetting) {
      const masterUser = yield select(selectCurrentMaster);

      yield put({
        type: DISPATCH_HACK,
        normalized: normalize(
          {
            _id: id,
            userSetting: currentUser.setting,
            setting: masterUser.setting,
            settings: masterUser.settings,
          },
          usersResource.schema,
        ),
      });
    }
  }
}
